import { setRoute } from "./callEngine";

export async function checkUserUsage(userId, stackId) {
  /*
  Check if the user has exceeded their usage limit
  Endpoint returns a boolean that indicates if the user is allowed to continue
   */
  const url =
    process.env.BASEURL +
    `/dashboard-users/validate/widget?user_id=${userId}&stack_id=${stackId}`;

  return fetch(url, {
    method: "GET",
    headers: {
      "X-MagicForm-Version": GITHASH,
    },
  }).then((res) => {
    setRoute(res.headers.get("X-MagicForm-Route"));
    return res.json();
  });
}
